import { MainLayoutSimple } from "components/layouts/MainLayoutSimple";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import AccountVerify from "../page";

const routes: AppRouteType[] = [
  {
    path: slugs.accountVerify,
    component: AccountVerify,
    container: MainLayoutSimple,
    isAuthNeeded: true,
  },
];

export default routes;
